import React, { useEffect, useState } from 'react'
import { useLocation, Outlet, Link } from 'react-router-dom'
import { Grid, Box, Typography, Tooltip, Paper, Stack, useMediaQuery } from '@mui/material'
import { PanaIcon } from '../../components/Icons'

import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { ContactlessOutlined } from '@mui/icons-material'
const AuthLayout = () => {
  const isMobile = useMediaQuery('(max-width: 600px)')
  const location = useLocation()
  const [hideIcons, setHideIcons] = useState(false)

  useEffect(() => {
    // console.log('location', location)
    if (
      location?.pathname === '/auth/privacy-terms' ||
      location?.pathname === '/auth/reset-password'
    ) {
      setHideIcons(true)
    } else {
      setHideIcons(false)
    }
  }, [location])
  return (
    <Box
      sx={{
        height: { xs: 'auto', md: '100dvh' },
        overflow: 'hidden',
        bgcolor: 'common.white',
        position: 'relative',
        paddingBottom: { xs: 10, md: 0 },
        justifyContent: 'center',
      }}
    >
      <Grid container sx={{ height: { xs: 'auto', md: 'calc(100% - 40px)' } }}>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: 'none',
              bgcolor: 'background.main',
              height: '100%',
            }}
          >
            <PanaIcon sx={{ width: '80%', height: '80%' }} />
          </Paper>
        </Grid>
        <Outlet />
      </Grid>
      <Paper
        sx={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',

          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'transparent',
          px: 2,
        }}
      >
        {/* <Typography
          variant='subtitle2'
          sx={{ color: 'text.primary', position: 'fixed', bottom: '1px' }}
        >
          © {new Date().getFullYear()} Lawttorney. All rights reserved
        </Typography> */}
      </Paper>
      {/* {!isMobile && ( */}
      {!hideIcons && (
        <Stack
          sx={{
            display: isMobile ? 'flex' : 'inlineBlock',
            flexDirection: isMobile ? 'row' : 'column',
            position: 'absolute',
            top: isMobile ? 'auto' : '300px',
            bottom: '10px',
            right: '10px',
            left: 'auto',
            zIndex: '10005',
          }}
        >
          <Link to='https://www.facebook.com/share/1BsFpAygTS/?mibextid=wwXIfr' target='_blank'>
            <Tooltip title='Facebook' placement='left'>
              <FacebookIcon
                fontSize='large'
                sx={{ mx: '10px', color: '#4267B2', cursor: 'pointer' }}
              />
            </Tooltip>
          </Link>

          <Link to='https://www.linkedin.com/company/lawttorneydotai/' target='_blank'>
            <Tooltip title='LinkedIn' placement='left'>
              <LinkedInIcon fontSize='large' sx={{ mx: '10px', color: '#0077B5' }} />
            </Tooltip>
          </Link>

          <Link
            to='https://www.instagram.com/lawttorney.ai?igsh=bWlrZzBnMnU5eDAw&utm_source=qr'
            target='_blank'
          >
            <Tooltip title='Instagram' placement='left'>
              <InstagramIcon fontSize='large' sx={{ mx: '10px', color: '#E1306C' }} />
            </Tooltip>
          </Link>

          <Link to='https://youtube.com/@lawttorney?si=uMh5Gil_6pChVfFo' target='_blank'>
            <Tooltip title='YouTube' placement='left'>
              <YouTubeIcon fontSize='large' sx={{ mx: '10px', color: 'red' }} />
            </Tooltip>
          </Link>
        </Stack>
      )}

      {/* // )} */}
    </Box>
  )
}

export default AuthLayout
